function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useUserAccount } from "./userAccount";
import { useMemo } from 'react';
import { ADVANCED_COMMISSION_ACCOUNT, APPLY_CREDIT_ACCOUNT, BalanceCategory, COMMISSION_ACCOUNT } from "../constants/balance";
var defaultBalances = {
  applyCreditAccount: {
    balances: []
  },
  commissionAccount: {
    balances: []
  },
  advancedCommissionAccount: {
    balances: []
  }
};
var mergeBalances = function mergeBalances(applyCreditAccount, commissionAccount, advancedCommissionAccount) {
  var balanceSignMapper = function balanceSignMapper(account) {
    return account.data.attributes.balances.map(function (balance) {
      return _objectSpread(_objectSpread({}, balance), {}, {
        amount: account.data.attributes.category === BalanceCategory.Liability ? -balance.amount : balance.amount
      });
    });
  };
  return {
    applyCreditAccount: {
      balances: balanceSignMapper(applyCreditAccount)
    },
    commissionAccount: {
      balances: balanceSignMapper(commissionAccount)
    },
    advancedCommissionAccount: {
      balances: balanceSignMapper(advancedCommissionAccount)
    }
  };
};
export var useBalances = function useBalances(billingAccountId, dataTransformer) {
  var applyCreditAccount = useUserAccount(billingAccountId, APPLY_CREDIT_ACCOUNT);
  var commissionAccount = useUserAccount(billingAccountId, COMMISSION_ACCOUNT);
  var advancedCommissionAccount = useUserAccount(billingAccountId, ADVANCED_COMMISSION_ACCOUNT);
  var balances = useMemo(function () {
    var isLoading = applyCreditAccount.isLoadingUserAccount || commissionAccount.isLoadingUserAccount || advancedCommissionAccount.isLoadingUserAccount;
    // only when all requests failed
    var isError = applyCreditAccount.userAccountError && commissionAccount.userAccountError && advancedCommissionAccount.userAccountError;
    var data = isLoading || isError ? defaultBalances : mergeBalances(applyCreditAccount.userAccount, commissionAccount.userAccount, advancedCommissionAccount.userAccount);
    return {
      isLoading: isLoading,
      isError: isError,
      data: dataTransformer(data)
    };
  }, [applyCreditAccount.isFetchingUserAccount, commissionAccount.isFetchingUserAccount, advancedCommissionAccount.isFetchingUserAccount]);
  return balances;
};